import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";

import { Button } from "@mui/material";
import { Modal, Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Box,
  Slide,
  Avatar
} from "@mui/material";
import AttendanceVeiwController from "../../redux/actions/AttendenceApiAction";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";


const legendData = [
  { code: "P", label: "Present", className: "present" },
  { code: "A", label: "Absent", className: "absent" },
  { code: "O", label: "Off Day", className: "offday" },
  { code: "R", label: "Rest Day", className: "restday" },
  { code: "L", label: "Leave", className: "leave" },
  { code: "H", label: "Holiday", className: "holiday" },
  { code: "½", label: "Half Day", className: "halfday" },
  { code: "OD", label: "On Duty", className: "onduty" },
  { code: "D", label: "Deduction", className: "deduction" },
  { code: "?", label: "Status Unknown", className: "unknown" },
  { code: "OT", label: "Overtime", className: "overtime" },
  { code: "E", label: "Early Logout", className: "early" }
  //   { code: "!", label: "Alert for Deduction", className: "alert-deduction" },
  //   { code: "↺", label: "Override", className: "override" },
  //   { code: "🚫", label: "Ignored", className: "ignored" },
  //   { code: "▲", label: "Grace", className: "grace" },
  //   { code: "▶", label: "Regularized", className: "regularized" },
];

const statusGradients = {
  A: "linear-gradient(135deg, #f8d7da 0%, #fbe9eb 100%)",
  O: "linear-gradient(135deg, #f1f8e9 0%, #f3f9ec 100%)",
  R: "linear-gradient(135deg, #e0f7fa 0%, #e9f9fb 100%)",
  L: "linear-gradient(135deg, #e38582 0%, #f1c2c1 100%)",
  E: "linear-gradient(135deg, #ffd699 0%, #ffebcc 100%)",
  P: "linear-gradient(135deg, #d4edda 0%, #dbf0e0 100%)"
  // default: "linear-gradient(135deg, #f0f0f0 0%, #d9d9d9 100%)" // default gray gradient
};

const AttendanceView = ({ show, handleClose, selectedEmployee }) => {
  const employeeId = selectedEmployee?.id;
  const { getMonthlyAttendance } = AttendanceVeiwController();
  const { monthly_summary } = useSelector((state) => state.TimeAttendance);

  const dispatch = useDispatch();

  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1); // month is 1-indexed for API
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const currentDate = new Date(selectedYear, selectedMonth - 1); // month is 0-indexed here
  // const BASE_URL = "http://localhost:8000";
  useEffect(() => {
    if (employeeId) {
      dispatch(getMonthlyAttendance(employeeId, selectedYear, selectedMonth));
    }
  }, [dispatch, employeeId, selectedMonth, selectedYear]);

  const formatTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr); // Handles +05:30
    const options = {
      timeZone: "Asia/Kolkata", // Use your local timezone
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    };
    return date.toLocaleString("en-GB", options);
  };

  const statusMap = {};

  if (monthly_summary?.attendance_records?.length) {
    monthly_summary.attendance_records.forEach((record) => {
      const date = record.date;
      statusMap[date] = {
        code: record.status,
        detail: record.holiday_details // e.g., "Kamgar Din"
      };
    });
  }

  const getMonthName = (date) => {
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };

  const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

  const getFirstDayOfMonth = (month, year) => {
    return new Date(year, month, 1).getDay(); // Sunday = 0
  };

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear((prev) => prev - 1);
    } else {
      setSelectedMonth((prev) => prev - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear((prev) => prev + 1);
    } else {
      setSelectedMonth((prev) => prev + 1);
    }
  };

  const isToday = (date) => {
    const today = new Date();
    return today.getDate() === date;
  };

  const attendanceRecord = monthly_summary?.attendance_records?.find(
    (record) => record.date === selectedDate.toLocaleDateString("en-CA")
  );

  const clockIn = attendanceRecord ? attendanceRecord.clock_in : null;
  const clockOut = attendanceRecord ? attendanceRecord.clock_out : null;
  const regularHours = attendanceRecord ? attendanceRecord.regular_hours : null;
  const overtimeHours = attendanceRecord
    ? attendanceRecord.overtime_hours
    : null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      // size="xl"
      // style={{ height: "100%" }}
      fullscreen
    >
      <div style={{ height: "90vh", display: "flex", flexDirection: "column" }}>
        <Modal.Header closeButton className="sticky-modal-header">
          <Modal.Title as="div">
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {/* Profile Image or Initials */}
              {selectedEmployee?.profile_image ? (
                <ProtectedImage
                  path={selectedEmployee?.profile_image}
                  alt={`Profile Photo`}
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    objectFit: "cover"
                  }}
                />
              ) : (
                // <Box
                //   component="img"
                //   src={
                //     selectedEmployee.profile_details.profile_image.startsWith(
                //       "data:"
                //     )
                //       ? selectedEmployee.profile_details.profile_image
                //       : `${IMAGE_URL}${selectedEmployee.profile_details.profile_image}`
                //   }
                //   alt="Profile"
                //   sx={{
                //     width: 56,
                //     height: 56,
                //     borderRadius: "50%",
                //     objectFit: "cover"
                //   }}
                // />
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    backgroundColor: "#1976d2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 20,
                    textTransform: "uppercase"
                  }}
                >
                  {selectedEmployee?.first_name?.[0]}
                  {selectedEmployee?.last_name?.[0]}
                </Box>
              )}

              {/* Text Info */}
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap"
                  }}
                >
                  <Typography variant="h6" fontWeight="bold">
                    {selectedEmployee?.first_name} {selectedEmployee?.last_name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    ({selectedEmployee?.employee_id || "N/A"})
                  </Typography>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: selectedEmployee?.is_active
                        ? "#00cc00"
                        : "red",
                      ml: 0.5
                    }}
                  />
                </Box>

                <Typography variant="body2" color="text.secondary">
                  {selectedEmployee?.designation || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ overflowY: "auto", flex: 1 }}
          // className="fixed-modal-body"
        >
          {selectedEmployee && (
            <Container>
              <Row>
                <Col>
                  <div className="calendar-container card mt-4 p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Button variant="outlined" onClick={handlePrevMonth}>
                        &lt; Prev
                      </Button>
                      <h5 className="mb-0">{getMonthName(currentDate)}</h5>
                      <Button variant="outlined" onClick={handleNextMonth}>
                        Next &gt;
                      </Button>
                    </div>
                    <div className="calendar-grid">
                      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                        (day) => (
                          <div className="calendar-header" key={day}>
                            {day}
                          </div>
                        )
                      )}
                      {Array(
                        getFirstDayOfMonth(
                          currentDate.getMonth(),
                          currentDate.getFullYear()
                        )
                      )
                        .fill(null)
                        .map((_, i) => (
                          <div
                            key={`empty-${i}`}
                            className="calendar-cell empty"
                          />
                        ))}
                      {Array(
                        daysInMonth(
                          currentDate.getMonth(),
                          currentDate.getFullYear()
                        )
                      )
                        .fill(null)
                        .map((_, i) => {
                          const date = i + 1;
                          const fullDate = new Date(
                            currentDate.getFullYear(),
                            currentDate.getMonth(),
                            date
                          ).toLocaleDateString("en-CA"); // YYYY-MM-DD format without UTC shift
                          const status = statusMap[fullDate] || " ";
                          const legendClass =
                            legendData.find((l) => l.code === status?.code)
                              ?.className || "unknown";
                          return (
                            <div
                              key={date}
                              className={`calendar-cell ${legendClass}`}
                              onClick={() =>
                                setSelectedDate(
                                  new Date(
                                    currentDate.getFullYear(),
                                    currentDate.getMonth(),
                                    date
                                  )
                                )
                              }
                            >
                              <div className="date-number">{date}</div>
                              <span
                                className={`symbol ${legendClass}`}
                                style={{ fontSize: "0.7rem" }}
                              >
                                {status?.code}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Col>
                <Col>
                  {(() => {
                    const dateKey = selectedDate.toLocaleDateString("en-CA");
                    const statusEntry = statusMap[dateKey];
                    const isHoliday = statusEntry?.code === "H";

                    if (isHoliday) {
                      return (
                        <Row>
                          <div
                            className="header single-row"
                            style={{
                              background:
                                "linear-gradient(135deg, #b8daff 0%, #e6f2ff 100%)",
                              padding: "1rem",
                              borderRadius: "10px",
                              color: "#333",
                              transition: "background 0.3s ease"
                            }}
                          >
                            <h5>Holiday</h5>
                            <p>
                              {selectedDate.toLocaleDateString("en-US", {
                                weekday: "long",
                                month: "long",
                                day: "numeric",
                                year: "numeric"
                              })}
                            </p>
                            <p>
                              <strong>
                                {statusEntry?.detail || "Holiday"}
                              </strong>
                            </p>
                          </div>
                        </Row>
                      );
                    }
                    return (
                      <>
                        <Row>
                          <div className="header single-row">
                            <Row>
                              <Col xs={4}>
                                <div className="date-section">
                                  <div className="date">
                                    {selectedDate.getDate()}
                                    <br />
                                    <span className="weekday">
                                      {selectedDate.toLocaleString("en-us", {
                                        weekday: "short"
                                      })}
                                    </span>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={4} className="text-center">
                                <div className="shift-section">
                                  <div className="shift-title">
                                    General (GEN)
                                  </div>
                                  <div className="timing">
                                    Shift: 09:00 to 18:00
                                  </div>
                                </div>
                              </Col>
                              <Col xs={4}>
                                <div className="scheme-section">
                                  <div className="scheme">General</div>
                                  <div className="scheme-type">
                                    Attendance Scheme
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Row>

                        <Row>
                          <div
                            className="attendance-card"
                            style={{
                              background:
                                statusGradients[statusEntry?.code] ||
                                statusGradients.default,
                              transition: "background 0.3s ease"
                            }}
                          >
                            {clockIn && (
                              <div className="processed-on">
                                Processed on
                                {statusEntry?.code === "E" && (
                                  <span className="early-logout-text">
                                    {" "}
                                    <p> Early Logout </p>
                                  </span>
                                )}
                              </div>
                            )}
                            {clockIn && <hr className="divider" />}
                            <Row>
                              {clockIn ? (
                                <>
                                  <Col xs={6}>
                                    <div className="clock-details">
                                      Clock In: {formatTime(clockIn)}
                                      <br />
                                      Clock Out:{" "}
                                      {clockOut ? formatTime(clockOut) : "-"}
                                    </div>
                                  </Col>
                                  <Col xs={6}>
                                    <div className="clock-details">
                                      Regular Hours: {regularHours || "-"}
                                      <br />
                                      Overtime Hours: {overtimeHours || "-"}
                                    </div>
                                  </Col>
                                </>
                              ) : (
                                <Col xs={12}>
                                  <div className="clock-details text-center">
                                    {statusEntry?.code === "A" && (
                                      <strong>
                                        {selectedEmployee?.first_name} was
                                        Absent
                                      </strong>
                                    )}
                                    {statusEntry?.code === "O" && (
                                      <strong>Off Day</strong>
                                    )}
                                    {statusEntry?.code === "R" && (
                                      <strong>Rest Day</strong>
                                    )}
                                    {statusEntry?.code === "L" && (
                                      <strong>
                                        {selectedEmployee?.first_name} on Leave
                                      </strong>
                                    )}
                                    {!["A", "O", "R", "L"].includes(
                                      statusEntry?.code
                                    ) && <strong>No attendance record</strong>}
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </Row>
                      </>
                    );
                  })()}
                  <Row>
                    <div className="legend-container card p-3 mt-4">
                      <h5 className="mb-3">Legends</h5>
                      <div className="legend-grid">
                        {legendData.map((item, index) => (
                          <div className="legend-item" key={index}>
                            <span className={`legend-symbol ${item.className}`}>
                              {item.code}
                            </span>
                            <span className="legend-label">{item.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Container>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default AttendanceView;
